import { OperatorType } from '../operator';
import { IntervalUnit } from '../timeout';
import { ValidatorResult } from '../validator';

import {
  ActionSetVarDateFromOperationServer,
  ActionSetVarNumberFromOperationServer,
  ActionSetVarSetServer,
  SetVarsKind,
  SetDateVarOperatorType
} from './server';

export interface ISetVarOperation<K extends SetVarsKind> {
  readonly kind: K;
  readonly listId: string;
  readonly error: ValidatorResult;
  validate: () => void;
  getCopy: () => ISetVarOperation<K>;
  isEqual: (rhs: ISetVarOperation<K>) => boolean;
  toJson(): mapKindToServer[K];
}

export type mapKindToServer = {
  [SetVarsKind.set]: ActionSetVarSetServer;
  [SetVarsKind.numOp]: ActionSetVarNumberFromOperationServer;
  [SetVarsKind.dateOp]: ActionSetVarDateFromOperationServer;
};

export const setDateVarUnitOrder = [
  IntervalUnit.days,
  IntervalUnit.hours,
  IntervalUnit.minutes,
  IntervalUnit.seconds
];

export const setDateVarOperatorOrder: SetDateVarOperatorType[] = [
  OperatorType.addition,
  OperatorType.subtraction
];

export const setNumberVarOperatorOrder: OperatorType[] = [
  OperatorType.addition,
  OperatorType.subtraction,
  OperatorType.multiplication,
  OperatorType.mod,
  OperatorType.division,
  OperatorType.integerDivision
];
